<body style="color: black;">
  <div id="root">
    <div id="app">
      <header class="App-header"></header>
      <main>
        <div class="background-loader" *ngIf="isLoading">
          <div class="sk-cube-grid">
            <div class="sk-cube sk-cube9"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube1"></div>
          </div>
        </div>

        <section class="preview-refused no-print" *ngIf="!isLoading && previewNotice">{{ previewNotice }}</section>

        <ng-container
          *ngIf="content && (content.ItemType == portalUrlTypeEnum.EstimateDetails || content.ItemType == portalUrlTypeEnum.EstimateChangeOrderDetails)">
          <section class="app-print-section" *ngIf="!isLoading && isExists">
            <projul-estimate [portalEstimate]="content"></projul-estimate>
          </section>
        </ng-container>

        <ng-container *ngIf="content && (content.ItemType == portalUrlTypeEnum.Invoice)">
          <ng-container *ngIf="!isLoading && isExists">
            <section id="intro-payment" class="paid-invoice no-print" style="display: block;padding: 1rem;"
              *ngIf="content.Item.RemainingBalance == 0 && content.Item.Status=== invoiceStatusEnum.Paid">
              <div class="f-a-center invoice-text-a">
                <div class="f-column f-grow f-a-start">
                  <h2 class="">Invoice Paid</h2>
                </div>
                <div class="f-column f-a-center pay-button"><i class="i-check-circle success"
                    style="font-size: 2.5rem; margin-right: 1rem;"></i></div>
              </div>
            </section>

            <section class="app-print-section">
              <projul-invoice [invoice]="content"></projul-invoice>
            </section>

            <section id="checkoutJustifi" class="no-print"
              *ngIf="!isLoading && isExists && ((integrationSettings.ViewJustiFiIntegrationForDemo) || content.isJustiFiIntegrationCompleted) && content.Item.RemainingBalance >= 1 && (content.Item.AcceptCreditCard || content.Item.AcceptACH) &&  integrationSettings.PaymentsEnabledForPastInvoices && content.Item.CustomerId !== null">
              <projul-justifi-payment [invoice]="content" [settings]="integrationSettings"></projul-justifi-payment>
            </section>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="content && (content.ItemType == portalUrlTypeEnum.ProjectReport)">
          <section class="app-print-section" *ngIf="!isLoading && isExists">
            <projul-project-report [portalUrlContentDetailsModal]="content"></projul-project-report>
          </section>
        </ng-container>

        <ng-container *ngIf="!isExists && !isLoading && !previewNotice">
          <section>
            <div class="message" style="padding: 1rem;">
              <div>
                <img alt="Welder" class="person-image"
                  src="data:image/png;base64,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">
              </div>
              <div class="h3">
                <span>The document you're looking for doesn't exist.</span>
              </div>
            </div>
          </section>
        </ng-container>

      </main>
      <footer>
        <div style="margin: 5rem;">
          <small style="color: white;">by</small>
          <img alt="Projul Logo" src="/assets/projul-logo-white.svg">
        </div>
      </footer>
    </div>
  </div>
</body>